import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { RoutingParamService } from '../Services/routing-param.service';
import { CommonService } from '../Services/common.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.css'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class MyAccountComponent implements OnInit, OnDestroy {
  public tabIndex = 0;
  isMobileView = false;
  private readonly subscriptions = new Subscription();
  selectedOptionToViewForMobile: string = '';

  private static readonly MOBILE_TAB_KEYS: string[] = [
    'WebinarFreeWinning',
    'PurchaseHistory',
    'CommunicationAddress',
    'CommunicationMethods',
    'PaymentMethods',
  ];

  constructor(private routingParam: RoutingParamService, private route: ActivatedRoute, private commonService: CommonService) {
    this.applyRouteTabParams(this.route.snapshot.paramMap);
   }

  ngOnInit(): void {
    this.subscriptions.add(this.commonService.isMobileView.subscribe(res => this.isMobileView = res));
    this.subscriptions.add(this.commonService.isPageReload.subscribe(res => {
      if (res === true) {
        location.reload();
      }
    }));
    this.subscriptions.add(this.route.paramMap.subscribe((params: ParamMap) => {
      this.applyRouteTabParams(params);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyRouteTabParams(paramMap: ParamMap): void {
    const raw = paramMap.get('isTab');
    if (raw === null || raw === undefined || raw === '') {
      this.tabIndex = 0;
      this.selectedOptionToViewForMobile = MyAccountComponent.MOBILE_TAB_KEYS[0];
      return;
    }
    const idx = Number(raw);
    if (!Number.isFinite(idx) || !Number.isInteger(idx) || idx < 0 || idx >= MyAccountComponent.MOBILE_TAB_KEYS.length) {
      this.tabIndex = 0;
      this.selectedOptionToViewForMobile = MyAccountComponent.MOBILE_TAB_KEYS[0];
      return;
    }
    this.tabIndex = idx;
    this.selectedOptionToViewForMobile = MyAccountComponent.MOBILE_TAB_KEYS[idx];
  }
}
